import React from "react";

function TextInput({
  label,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  error,
  icon,
  required,
  ...props
}) {
  return (
    <div className="mb-5">
      {label && (
        <label
          htmlFor={name}
          className="mb-2 block font-medium text-gray-700"
        >
          {label}
          {required && <span className="ml-1 text-error">*</span>}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
            {icon}
          </div>
        )}
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={`input ${icon ? "pl-10" : ""} ${
            error ? "input-error" : ""
          } ${props.disabled ? "cursor-not-allowed bg-gray-50 text-gray-500" : ""}`}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-2 flex items-center gap-1 text-sm text-error animate-fadeIn">
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
}

export default TextInput;
